module.exports = __webpack_public_path__ + "static/usaspirits-silver-77576390c4416af46dedaa3709e6d119.jpg";